<!-- This example requires Tailwind CSS v2.0+ -->
<div class="flex flex-col">
  <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
    <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
      <div class="shadow overflow-hidden border-b border-edge sm:rounded-lg">
        <table class="min-w-full divide-y divide-separator">
          <thead class="bg-surface-secondary">
            <tr>
              <th
                scope="col"
                class="px-6 py-3 text-left text-xs font-medium text-fg-secondary uppercase tracking-wider"
              >
                Projektname
              </th>
              <th
                scope="col"
                class="px-6 py-3 text-left text-xs font-medium text-fg-secondary uppercase tracking-wider"
              >
                Total
              </th>
              <th
                scope="col"
                class="px-6 py-3 text-left text-xs font-medium text-fg-secondary uppercase tracking-wider"
              >
                Verrechenbar
              </th>
              <th
                scope="col"
                class="px-6 py-3 text-left text-xs font-medium text-fg-secondary uppercase tracking-wider"
              >
                Nicht verrechenbar
              </th>
            </tr>
          </thead>
          <tbody class="bg-surface">
            <ng-content></ng-content>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
